import { logger } from '@lusha/client-logger';
import { flow } from 'mobx-state-tree';
import { getPricingPlans } from '../../../API/pricingApi';
const Actions = self => ({
    fetchPricingPlans: flow(function* fetchPricingPlans() {
        if (self.isLoading)
            return;
        self.isLoading = true;
        try {
            const data = yield getPricingPlans();
            self.pricingVersion = (data === null || data === void 0 ? void 0 : data.pricing_version) || null;
            self.experienceMode = (data === null || data === void 0 ? void 0 : data.experience_mode) || null;
            self.experimentVariant = (data === null || data === void 0 ? void 0 : data.experiment_variant) || null;
            self.hierarchyStep = (data === null || data === void 0 ? void 0 : data.hierarchy_step) || null;
            self.isCrossVersionUser = (data === null || data === void 0 ? void 0 : data.is_cross_version_user) || false;
            self.plans = (data === null || data === void 0 ? void 0 : data.plans) || [];
            self.seatProducts = (data === null || data === void 0 ? void 0 : data.seatProducts) || [];
            self.pricingPlanFeatures = (data === null || data === void 0 ? void 0 : data.pricingPlanFeatures) || null;
            self.isLoaded = true;
        }
        catch (err) {
            logger.error(`Failed to fetch pricing plans ${JSON.stringify(err)}`, { err });
            self.isLoaded = false;
            self.isModalVisible = false;
            window.open(envConfig.MARKETING_URL, '_blank');
        }
        finally {
            self.isLoading = false;
        }
    }),
    setModalVisible(value) {
        self.isModalVisible = value;
    },
    openUpgradeModal: flow(function* openUpgradeModal(source) {
        self.isModalVisible = true;
        self.openSource = source;
        yield self.fetchPricingPlans();
    }),
    closeUpgradeModal() {
        self.isModalVisible = false;
    },
});
export default Actions;
